module.exports = __webpack_public_path__ + "img/34_16.358b2abe.png";